import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IonColor } from '../../types/ion-color.type';

@Component({
  selector: 'shared-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrl: './status-tag.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusTagComponent {
  readonly color = input<IonColor>('primary');
  readonly tag = input('');
}
